import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { TokenWatcherService } from '../../services/token-watcher.service';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-session-expiry-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule],
  template: `
    <p-dialog
      [visible]="isWarning()"
      [modal]="true"
      [closable]="false"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '420px' }"
      styleClass="session-expiry-dialog"
      header="⚠️ Sesión por vencer"
    >
      <div class="session-expiry-body">
        <p class="session-expiry-msg">
          Tu sesión expirará en
          <strong class="session-expiry-countdown" [class.urgent]="secondsLeft() <= 30">
            {{ formatTime(secondsLeft()) }}
          </strong>
        </p>
        <p class="session-expiry-sub">¿Deseas mantener la sesión activa?</p>
      </div>

      <ng-template pTemplate="footer">
        <button
          pButton
          label="Cerrar sesión"
          icon="pi pi-sign-out"
          class="p-button-outlined p-button-danger"
          (click)="onLogout()"
        ></button>
        <button
          pButton
          label="Mantener sesión"
          icon="pi pi-refresh"
          class="p-button-success"
          [loading]="renewing"
          (click)="onRenew()"
        ></button>
      </ng-template>
    </p-dialog>
  `,
  styles: [`
    :host ::ng-deep .session-expiry-dialog .p-dialog-header {
      background: #fff3cd;
      color: #856404;
      border-bottom: 1px solid #ffc107;
      font-weight: 600;
    }

    .session-expiry-body {
      padding: 0.5rem 0;
      text-align: center;
    }

    .session-expiry-msg {
      font-size: 1.05rem;
      margin-bottom: 0.5rem;
    }

    .session-expiry-sub {
      color: #6c757d;
      font-size: 0.9rem;
      margin-bottom: 0;
    }

    .session-expiry-countdown {
      font-size: 1.5rem;
      font-weight: 700;
      color: #e67e22;
      display: inline-block;
      min-width: 3.5rem;
      text-align: center;
      transition: color 0.3s;

      &.urgent {
        color: #dc3545;
        animation: pulse 1s infinite;
      }
    }

    @keyframes pulse {
      0%, 100% { opacity: 1; }
      50%       { opacity: 0.5; }
    }
  `]
})
export class SessionExpiryDialogComponent {
  private readonly watcher = inject(TokenWatcherService);
  private readonly authSvc = inject(AuthService);

  renewing = false;

  readonly isWarning  = computed(() => this.watcher.sessionState() === 'warning');
  readonly secondsLeft = computed(() => this.watcher.secondsLeft());

  formatTime(secs: number): string {
    if (secs <= 0) return '0:00';
    const m = Math.floor(secs / 60);
    const s = secs % 60;
    return `${m}:${s.toString().padStart(2, '0')}`;
  }

  onRenew(): void {
    this.renewing = true;
    this.authSvc.refreshToken().subscribe({
      next: () => {
        this.renewing = false;
        // El watcher detecta el tokenRenewed$ y cierra el diálogo automáticamente
      },
      error: () => {
        this.renewing = false;
        this.authSvc.lockScreen();
      }
    });
  }

  onLogout(): void {
    this.authSvc.logout();
  }
}
